var AC_Graph = {
  version: 1,
  url_base: "",
  whitelist: ["interaction_rate"]
};
module.exports = AC_Graph;